import { FormItem } from '@eastcoal/formily/components/FormItem'
import { Input } from '@eastcoal/formily/components/Input'
import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'
import { Select } from '@eastcoal/formily/components/Select'
import { UploadFile } from '@eastcoal/formily/components/UploadFile'

import { CertificationManage } from '@eastcoal/shared/@formily/CertificationManage'
import { MemberAgentCascader } from '@eastcoal/shared/@formily/MemberAgentCascader'
import { RegionCascader } from '@eastcoal/shared/@formily/RegionCascader'
import {
  EnterpriseSize,
  EnterpriseSizeMap
} from '@eastcoal/shared/enums/EnterpriseSize'

import { AgentFeedBackText } from '../components/AgentFeedBackText'

export const otherSchema: Record<string, SchemaItem> = {
  '{id: agentId,name: agentName}': {
    type: 'object',
    title: '业务受托人',
    'x-component': MemberAgentCascader,
    'x-decorator': FormItem
  },
  '[agentOssId]': {
    type: 'array',
    title: '委托说明书',
    'x-component': UploadFile,
    'x-component-props': {
      multiple: false,
      maxCount: 1
    },
    'x-decorator': FormItem,
    'x-decorator-props': {
      help: <AgentFeedBackText />
    }
  },
  [`
    {
      province:{
        id: provinceId,
        name: provinceName
      },
      city:{
        id: cityId,
        name: cityName
      },
      district:{
        id: districtId,
        name: districtName
      }
    }
  `]: {
    type: 'object',
    title: '所属城市',
    required: true,
    'x-component': RegionCascader,
    'x-decorator': FormItem
  },
  address: {
    type: 'string',
    title: '详细地址',
    required: true,
    'x-component': Input,
    'x-decorator': FormItem
  },
  enterpriseSize: {
    title: '企业规模',
    type: 'string',
    enum: [
      {
        label: EnterpriseSizeMap[EnterpriseSize.MICRO],
        value: EnterpriseSize.MICRO
      },
      {
        label: EnterpriseSizeMap[EnterpriseSize.SMALL],
        value: EnterpriseSize.SMALL
      },
      {
        label: EnterpriseSizeMap[EnterpriseSize.MEDIUM],
        value: EnterpriseSize.MEDIUM
      },
      {
        label: EnterpriseSizeMap[EnterpriseSize.LARGE],
        value: EnterpriseSize.LARGE
      }
    ],
    'x-component': Select,
    'x-decorator': FormItem
  },
  '[bankAccountOssId]': {
    title: '银行开户信息',
    type: 'array',
    required: true,
    'x-decorator': FormItem,
    'x-component': UploadFile,
    'x-component-props': {
      multiple: false,
      maxCount: 1
    }
  },
  certifications: {
    title: '其他资质证明',
    type: 'array',
    'x-decorator': FormItem,
    'x-decorator-props': {
      wrapperWidth: '100%'
    },
    'x-component': CertificationManage
  }
}
